@if (question.hasOwnProperty('resourcelist') && question.resourcelist.length>0) {
  <div class="row _app-inc-exc-container">
    @if (container.show_first && container.config_1 && question.resourcelist[0]['label']) {
      <div class="flex-1 inclusion-col p-2">
        <h4>{{question.resourcelist[0]['label']?(question.resourcelist[0]['label'] | translate | async):''}}</h4>
        <dhs-editable-grid [resource]="question.resourcelist[0]['resource']"
          (listen_changes)="listen_changes_1($event)" [config]="container.config_1">
        </dhs-editable-grid>
      </div>
    }
    @if (container.show_second && container.config_2 && question.resourcelist[1]['label']) {
      <div class="flex-1 inclusion-col p-2">
        <h4>{{question.resourcelist[1]['label']?(question.resourcelist[1]['label'] | translate | async):''}}</h4>
        <dhs-editable-grid [resource]="question.resourcelist[1]['resource']"
          (listen_changes)="listen_changes_2($event)" [config]="container.config_2">
        </dhs-editable-grid>
      </div>
    }
  </div>
}